import React, { useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Container, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from 'slices';
import { Formik, FormikProps } from 'formik';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  setActivePointsHistoryIndex,
  setPointsHistoryCurrentPage,
  setPointsHistoryModalOpen,
  setShowAllValidatePointsHistoryErrors,
} from 'slices/customer/reducer';

import { CustomerPointsModalValue } from 'types/customer/customerTypes';
import PointsHistoryForm from 'pages/Customers/CustomerPointsHistoryModal/PointsHistoryForm';

const CustomerPointsHistoryModal = () => {
  const { t } = useTranslation();
  const dispatch: ThunkDispatch<RootState, void, Action> = useDispatch();

  const formikRef = useRef<FormikProps<CustomerPointsModalValue>>(null);

  const pointsHistoryState = useSelector(
    (state: RootState) => state.Customer.PointsHistoryModal
  );
  const { PointsHistoryModalOpen, countSubmit, PointsHistoryValues } =
    pointsHistoryState;

  const toggleModal = useCallback(
    (index: number | null = null) => {
      dispatch(setPointsHistoryModalOpen(!PointsHistoryModalOpen));
      dispatch(setActivePointsHistoryIndex(index));
    },
    [PointsHistoryModalOpen, dispatch]
  );

  const closeModal = () => {
    toggleModal(null);
    dispatch(setPointsHistoryCurrentPage(0));
  };

  useEffect(() => {
    if (formikRef.current && formikRef.current.errors) {
      const errorKeys = Object.keys(formikRef.current.errors);
      if (errorKeys.length > 0) {
        const firstErrorField = document.querySelector(
          `[name="${errorKeys[0]}"]`
        ) as HTMLInputElement | null;

        if (
          firstErrorField !== null &&
          firstErrorField.type === 'hidden' &&
          firstErrorField.name === 'category'
        ) {
          const relatedElement = document.querySelector(
            '#react-select-2-input'
          ) as HTMLInputElement | null;

          if (relatedElement) {
            relatedElement.focus();
          }
        } else {
          if (firstErrorField) firstErrorField.focus();
        }
      }
    }
  }, [formikRef, countSubmit]);

  return (
    <React.Fragment>
      <div className={`page-content`}>
        <Container fluid>
          <Modal
            size="lg"
            // style={{ maxWidth: '960px', width: 'auto' }}
            isOpen={PointsHistoryModalOpen}
            toggle={() => {
              closeModal();
              dispatch(setShowAllValidatePointsHistoryErrors(false));
            }}
            backdrop={'static'}
            centered
          >
            <ModalHeader
              className="bg-light p-3"
              toggle={() => {
                closeModal();
                dispatch(setShowAllValidatePointsHistoryErrors(false));
              }}
            >
              {t('Points History')}
            </ModalHeader>
            <ModalBody>
              <Formik<CustomerPointsModalValue>
                initialValues={PointsHistoryValues}
                onSubmit={async (_values: CustomerPointsModalValue) => {}}
                enableReinitialize={true}
                innerRef={formikRef}
              >
                {(formik) => (
                  <form noValidate className="" onSubmit={formik.handleSubmit}>
                    <PointsHistoryForm formik={formik} dispatch={dispatch} />
                  </form>
                )}
              </Formik>
            </ModalBody>
          </Modal>
        </Container>
        <ToastContainer closeButton={false} limit={1} />
      </div>
    </React.Fragment>
  );
};
export default CustomerPointsHistoryModal;
